import script from "./DigithiaTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DigithiaTable.vue?vue&type=script&setup=true&lang=ts"

import "./DigithiaTable.vue?vue&type=style&index=0&id=61a1b196&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a1b196"]])

export default __exports__